import { mountRootParcel } from 'single-spa';
import { AnalyticsServiceFactory } from '@easygenerator/client-sdk.analytics';
import { UserContextServiceFactory } from '@easygenerator/client-sdk.user-context';
import { FeatureFlagsServiceFactory } from '@easygenerator/client-sdk.feature-flags';
import { FragmentsServiceFactory } from '@easygenerator/client-sdk.fragments';
import {
  AuthClientId,
  ClientAuthStrategy,
  FragmentName,
  FragmentsLoaderProvider,
  UserContextProvider
} from '@easygenerator/client-sdk.common';
import config from './config';

window.discoveryServiceUrl = config.discoveryServiceUrl;
window.tokenServiceUrl = config.tokenServiceUrl;
window.reportAnalyticsServiceUrl = config.reportAnalyticsServiceUrl;
window.npsServiceUrl = config.npsServiceUrl;
window.lrsServiceUrl = config.lrsServiceUrl;
window.editorServiceUrl = config.editorServiceUrl;
window.editorClientUrl = config.editorClientUrl;
window.authServiceUrl = config.authServiceUrl;
window.resultsClientUrl = config.resultsClientUrl;
window.analyticsWriteKey = config.segmentAppId;
window.featureFlagsClientKey = config.featureFlagsClientKey;
window.featureFlagsServiceUrl = config.featureFlagsServiceUrl;
window.translationServiceUrl = config.translationServiceUrl;

(async () => {
  async function setupFeatureFlagsService() {
    let accountId = '';
    const context = {
      email: '',
      language: '',
      organizationId: '',
      hostname: window.location.hostname
    };
    try {
      accountId = await UserContextProvider.userContext.accountId;
      const userOrganization = await UserContextProvider.userContext.organization;

      context.email = await UserContextProvider.userContext.email;
      context.language = await UserContextProvider.userContext.language;
      context.organizationId = userOrganization ? userOrganization.id : '';
      context.hostname = window.location.hostname;
    } catch (e) {}
    FeatureFlagsServiceFactory.initialize({
      serviceUrl: window.featureFlagsServiceUrl,
      clientKey: window.featureFlagsClientKey,
      applicationName: 'material-results-client',
      accountId,
      context
    });
  }

  const authTokenProvider = new ClientAuthStrategy({
    authServiceUrl: config.authServiceUrl,
    clientId: AuthClientId.results
  });
  UserContextServiceFactory.initialize({ tokenProvider: authTokenProvider });

  FragmentsServiceFactory.initialize();

  await setupFeatureFlagsService();

  AnalyticsServiceFactory.initialize({
    analyticsEnabled: config.analyticsEnabled,
    segmentWriteKey: config.segmentAppId,
    nativeMixpanel: {
      projectId: config.mixpanelProjectToken,
      projectName: config.mixpanelProjectName,
      isPageViewTrackingDisabled: true,
      isSessionRecordingDisabled: true
    },
    intercom: {
      appId: ''
    }

  });

  const fragment = await FragmentsLoaderProvider.fragmentsLoader.loadFragment(FragmentName.materialResults);
  mountRootParcel(fragment, {
    initializePermissions: false,
    initializationData: {},
    domElement: '#app'
  });
})();
